import React, { useState } from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { StatusBadge } from "../common/SectionCommon";
import "../common/common.scss";
import "./AuditorGuide.scss";

function Requisito({ a, st, t }) {
  const [abierto, setAbierto] = useState(false);
  const g = P.AUDIT_GUIDE[a.cl] || {};
  return (
    <div className="ep-guide__item">
      <button type="button" className="ep-guide__head" aria-expanded={abierto} onClick={() => setAbierto(!abierto)}>
        <span className="ep-mono">{a.cl}</span>
        <span className="ep-guide__req">{a.req}</span>
        {st && <StatusBadge estado={P.LBL_VIS[st.label] || st.label} />}
      </button>
      {abierto && (
        <div className="ep-guide__body">
          <div>
            <p><strong>{t("energy_performance_guide_ask")}:</strong></p>
            <ul>{(g.pedir || []).map((x, i) => <li key={i}>{x}</li>)}</ul>
            <p><strong>{t("energy_performance_guide_why")}:</strong> {g.porque}</p>
            {st && <p><strong>{t("energy_performance_guide_status")}:</strong> {st.hallazgo || "—"}{" "}
              <span className="ep-section__note">{(st.evid || []).length ? `· ${t("energy_performance_guide_evidence_present")}: ${st.evid.join(" · ")}` : `· ${t("energy_performance_guide_no_evidence")}`}</span></p>}
          </div>
          <div>
            <p><strong>{t("energy_performance_guide_onsite")}:</strong> {g.sitio}</p>
            <p className="ep-guide__alert"><strong>{t("energy_performance_guide_alerts")}:</strong></p>
            <ul className="ep-guide__alert">{(g.alertas || []).map((x, i) => <li key={i}>{x}</li>)}</ul>
            {g.entrevista && <p><strong>{t("energy_performance_guide_interview")}</strong> — {g.entrevista.rol}: <em>«{g.entrevista.q}»</em></p>}
            {g.resp && <p className="ep-section__note">{t("energy_performance_seu_responsible")}: {g.resp}</p>}
          </div>
        </div>
      )}
    </div>
  );
}

// Guía de verificación interna: qué pedir, por qué y cómo comprobarlo en la planta (28 requisitos).
export function AuditorGuide({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const { f } = useEnergia(installation);
  const audit = f ? f._audit : {};
  const core = P.AUDIT_CHECKLIST.filter((a) => P.CORE_MEDICION_CLS.includes(a.cl));
  const gestion = P.AUDIT_CHECKLIST.filter((a) => !P.CORE_MEDICION_CLS.includes(a.cl));
  return (
    <div className="ep-screen ep-guide">
      <h3 className="ep-screen__title">{t("energy_performance_guide_title")}</h3>
      <p className="ep-screen__intro">{t("energy_performance_guide_intro")}</p>
      <h4 className="ep-section__title">{t("energy_performance_audit_core")}</h4>
      {core.map((a) => <Requisito key={a.cl} a={a} st={audit[a.cl]} t={t} />)}
      <h4 className="ep-section__title">{t("energy_performance_audit_management")}</h4>
      {gestion.map((a) => <Requisito key={a.cl} a={a} st={audit[a.cl]} t={t} />)}
    </div>
  );
}
